import ProcedureScoresAPI from '../../api/procedureScores';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
  },
};

const getters = {
  getRecords: $state => $state.records,
  getUIFlags: $state => $state.uiFlags,
  getById: $state => id => $state.records.find(e => e.id === Number(id)),
};

const mutations = {
  SET($state, records) {
    $state.records = records;
  },
  UPSERT($state, record) {
    const idx = $state.records.findIndex(e => e.id === record.id);
    if (idx !== -1) {
      $state.records.splice(idx, 1, record);
    } else {
      $state.records.push(record);
    }
  },
  DELETE($state, id) {
    $state.records = $state.records.filter(e => e.id !== id);
  },
  SET_UI_FLAG($state, flag) {
    $state.uiFlags = { ...$state.uiFlags, ...flag };
  },
};

const actions = {
  async fetch({ commit }) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const { data } = await ProcedureScoresAPI.get();
      commit('SET', Array.isArray(data) ? data : data.payload || []);
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  async create({ commit }, payload) {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const { data } = await ProcedureScoresAPI.create({
        procedure_score_config: payload,
      });
      commit('UPSERT', data);
      return data;
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },

  async update({ commit }, { id, ...updateData }) {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const { data } = await ProcedureScoresAPI.update(id, {
        procedure_score_config: updateData,
      });
      commit('UPSERT', data);
      return data;
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },

  async delete({ commit }, id) {
    await ProcedureScoresAPI.delete(id);
    commit('DELETE', id);
  },
};

export default { namespaced: true, state, getters, mutations, actions };
